import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MessageCircle, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/">
              <img
                src="https://customer-assets.emergentagent.com/job_4a150f39-c075-4c53-a862-1e5bef838f84/artifacts/lgkcbt00_image.png"
                alt="D'Avocado Swimwear"
                className="h-16 md:h-20 w-auto mb-6 transition-all duration-300 hover:opacity-90 hover:scale-105 drop-shadow-lg"
              />
            </Link>
            <p className="text-white/60 text-sm leading-relaxed">
              Trajes de baño de diseñador venezolano. Elegancia, calidad y estilo único para la mujer moderna.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-gold font-accent text-lg tracking-widest uppercase mb-6">Enlaces</h4>
            <ul className="space-y-3">
              {[
                { href: '/tienda', label: 'Tienda' },
                { href: '/nosotros', label: 'Nosotros' },
                { href: '/guia-de-tallas', label: 'Guía de Tallas' },
                { href: '/faq', label: 'Preguntas Frecuentes' },
                { href: '/contacto', label: 'Contacto' },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/60 hover:text-gold text-sm transition-colors duration-300"
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-gold font-accent text-lg tracking-widest uppercase mb-6">Categorías</h4>
            <ul className="space-y-3">
              {[
                { href: '/tienda/bikinis', label: 'Bikinis' },
                { href: '/tienda/enterizos', label: 'Enterizos' },
                { href: '/tienda/salidas-de-bano', label: 'Salidas de Baño' },
                { href: '/tienda/accesorios', label: 'Accesorios' },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-white/60 hover:text-gold text-sm transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-gold font-accent text-lg tracking-widest uppercase mb-6">Contacto</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="https://wa.me/584242925792"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-white/60 hover:text-gold text-sm transition-colors duration-300"
                >
                  <MessageCircle className="w-4 h-4 mr-3 text-gold" />
                  +58 424 292 5792
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/davocadoswimwear"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-white/60 hover:text-gold text-sm transition-colors duration-300"
                >
                  <Instagram className="w-4 h-4 mr-3 text-gold" />
                  @davocadoswimwear
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@davocadoswimwear.com"
                  className="flex items-center text-white/60 hover:text-gold text-sm transition-colors duration-300"
                >
                  <Mail className="w-4 h-4 mr-3 text-gold" />
                  info@davocadoswimwear.com
                </a>
              </li>
              <li className="flex items-start text-white/60 text-sm">
                <MapPin className="w-4 h-4 mr-3 text-gold flex-shrink-0 mt-0.5" />
                <span>Venezuela</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} D'Avocado Swimwear. Todos los derechos reservados.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a
              href="https://instagram.com/davocadoswimwear"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/40 hover:text-gold transition-colors duration-300"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              href="https://wa.me/584242925792"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/40 hover:text-gold transition-colors duration-300"
              aria-label="WhatsApp"
            >
              <MessageCircle className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
